import React from 'react';
import CrearInsumos from '../../../components/insumos/insumos/CrearInsumos';

const InsumosPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
      <h1>Crear Insumos</h1>
      <br />
      <br />
      <CrearInsumos />
    </div>
  );
};

export default InsumosPage;